export default function HeroSection() {
  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[680px] flex items-center overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Cinematic%20dark%20atmosphere%20with%20warm%20coral%20red%20and%20deep%20charcoal%20gradient%2C%20abstract%20flowing%20film%20strips%20and%20soft%20bokeh%20lights%2C%20premium%20movie%20streaming%20platform%20hero%20background%2C%20elegant%20and%20dynamic%20visual%20with%20rich%20texture%2C%20modern%20entertainment%20aesthetic&width=1600&height=900&seq=hero-bg-main&orientation=landscape"
          alt="51视频 - 蓝光4K超清视频在线观看平台"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/45 to-black/65"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 py-20 md:py-24">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex flex-wrap items-center justify-center lg:justify-start gap-2 mb-6">
              <span className="px-3 py-1 text-xs font-medium rounded-full bg-primary-500/20 text-primary-200 border border-primary-500/30">
                蓝莓视频
              </span>
              <span className="px-3 py-1 text-xs font-medium rounded-full bg-accent-500/20 text-accent-200 border border-accent-500/30">
                糖心视频
              </span>
              <span className="px-3 py-1 text-xs font-medium rounded-full bg-secondary-500/20 text-secondary-200 border border-secondary-500/30">
                黑桃视频
              </span>
              <span className="px-3 py-1 text-xs font-medium rounded-full bg-white/10 text-white/80 border border-white/20">
                妖精视频
              </span>
            </div>

            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-heading font-bold text-white leading-tight mb-4">
              51视频 · 蓝光4K超清视频在线观看
            </h1>

            <p className="text-lg md:text-xl text-white/80 font-heading mb-8">
              无广告不缓冲，畅享极致观影体验
            </p>

            <p className="text-sm md:text-base text-white/65 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-8">
              51视频汇聚蓝莓视频、糖心视频、黑桃视频、妖精视频四大专区的海量高清资源，覆盖热门大片、高分剧集、经典老片和同步番剧。全站蓝光4K超清画质呈现，自建CDN加速网络确保播放流畅不缓冲，完全免费无广告。片库每周更新，目前已收录超过15,000部优质影视内容，是您在线观影的最佳选择。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mb-8">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-white">15,000+</div>
                <div className="text-xs md:text-sm text-white/55 mt-1">高清片库</div>
              </div>
              <div className="w-px h-10 bg-white/20 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-accent-400">4K蓝光</div>
                <div className="text-xs md:text-sm text-white/55 mt-1">超清画质</div>
              </div>
              <div className="w-px h-10 bg-white/20 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-primary-400">零广告</div>
                <div className="text-xs md:text-sm text-white/55 mt-1">纯净观影</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#media"
                className="w-full sm:w-auto px-8 py-3 bg-primary-500 hover:bg-primary-600 text-white font-semibold rounded-lg transition-all duration-200 text-center whitespace-nowrap"
              >
                <i className="ri-play-circle-line mr-2"></i>开始观看
              </a>
              <a
                href="#about"
                className="w-full sm:w-auto px-8 py-3 bg-white/10 hover:bg-white/20 text-white font-medium rounded-lg border border-white/30 transition-all duration-200 text-center whitespace-nowrap"
              >
                了解更多
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[500px] lg:max-w-none">
            <div className="relative rounded-xl overflow-hidden aspect-[4/3] bg-black/30">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20streaming%20platform%20interface%20with%20floating%20movie%20posters%20and%20film%20frames%20in%20warm%20coral%20and%20golden%20tones%2C%20dark%20cinematic%20background%20with%20soft%20glow%20effects%2C%20elegant%20entertainment%20UI%20aesthetic%2C%20premium%20video%20platform%20visual&width=800&height=600&seq=hero-visual-main&orientation=landscape"
                alt="51视频平台界面预览"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-4 flex items-center gap-3">
                <div className="w-3 h-3 rounded-full bg-primary-500 animate-pulse"></div>
                <span className="text-white/80 text-sm font-medium">蓝光4K 正在热播</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 hidden md:block">
        <a
          href="#comments"
          className="w-10 h-10 flex items-center justify-center text-white/60 hover:text-white transition-colors animate-bounce"
        >
          <i className="ri-arrow-down-s-line text-2xl"></i>
        </a>
      </div>
    </section>
  );
}